import {css} from "styled-components";
import currentTheme from "../../../react-themes/theme";

const theme = currentTheme();

const LayoutCss = css`
  .mobile-container {
    padding: 0 15px;
  }

  .z-index-top-layer {
    z-index: 4;
  }
  
  .z-index-1 {
    z-index: 1;
  }

  .farmy-column-set {
    display: flex;
    flex-direction: row;
  }

  .farmy-container {
    width: 100%;
    max-width: ${theme.contentWidth};
  }

  .flex {
    display: flex;
  }

  .inline-flex {
    display: inline-flex;
  }

  .flex-grow-1 {
    flex-grow: 1;
  }

  .flex-grow-0 {
    flex-grow: 0;
  }

  .flex-shrink-1 {
    flex-shrink: 1;
  }

  .flex-shrink-0 {
    flex-shrink: 0;
  }

  .flex-wrap {
    flex-wrap: wrap;
  }

  .full-width {
    width: 100%;
  }

  .full-height {
    height: 100%;
  }

  .full-width-sm {
    @media all and (max-width: ${theme.breakPoints.sm}px) {
      width: 100%
    }
  }

  .full-max-size {
    max-width: 100%;
    max-height: 100%;
  }

  .circle-container {
    border-radius: 50%;
  }

  .top-0 {
    top: 0;
  }

  .bottom-0 {
    bottom: 0;
  }

  .left-0 {
    left: 0;
  }

  .right-0 {
    right: 0;
  }

  .hidden-sm {
    @media screen and (max-width: ${theme.breakPoints.sm}px) {
      visibility: hidden;
    }
  }

  .line-clamped {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;

    &.clamped-2-lines {
      -webkit-line-clamp: 2;
    }

    &.clamped-3-lines {
      -webkit-line-clamp: 3;
    }

    &.clamped-4-lines {
      -webkit-line-clamp: 4;
    }

    &.clamped-5-lines {
      -webkit-line-clamp: 5;
    }
  }

  .background-image-cover {
    background-size: cover;
    background-position: center;
  }

  .placeholder-background {
    background: linear-gradient(to right, ${theme.colors.farmy.dimmedWhite} 45% 45%, ${theme.colors.farmy.almostWhite} 50%, ${theme.colors.farmy.dimmedWhite} 60%);
    background-size: 200% 200%;
    animation: placeholder-gradient 2s linear infinite;
  }

  @keyframes placeholder-gradient {
    0% {
      background-position: 0 50%;
    }
    100% {
      background-position: 200% 50%;
    }
  }
`;

export default LayoutCss;
